export enum ToastRoles {
	DISMISS = "dismiss",
	UPDATE = "update",
}
